/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_WordsInputs */

const en_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`big idea.|platform.|product.|0→1 build.|MVP.|revenue engine.|launch.|SaaS.|vision.|milestone.|competitive edge.|growth lever.|market move.|flagship feature.|Supabase app`)
};

const ar_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فكرتك الكبيرة.|منصتك.|منتجك.|بناء من 0 إلى 1.|MVP.|محرك إيرادات.|إطلاقك.|SaaS.|رؤيتك.|محطتك التالية.|أفضليتك التنافسية.|رافعة نموك.|خطوتك السوقية.|ميزتك الرئيسية.|تطبيق Supabase`)
};

const bn_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বড় আইডিয়া।|প্ল্যাটফর্ম।|প্রোডাক্ট।|0→1 বিল্ড।|MVP।|রেভিনিউ ইঞ্জিন।|লঞ্চ।|SaaS।|ভিশন।|মাইলস্টোন।|কম্পিটিটিভ এজ।|গ্রোথ লিভার।|মার্কেট মুভ।|ফ্ল্যাগশিপ ফিচার।|Supabase অ্যাপ`)
};

const de_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`große Idee.|Plattform.|Produkt.|0→1 Build.|MVP.|Umsatzmotor.|Start.|SaaS.|Vision.|Meilenstein.|Wettbewerbsvorteil.|Wachstumshebel.|Marktbewegung.|Flaggschiff-Funktion.|Supabase-App`)
};

const es_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gran idea.|plataforma.|producto.|0→1 build.|MVP.|motor de ingresos.|lanzamiento.|SaaS.|visión.|hito.|ventaja competitiva.|palanca de crecimiento.|movimiento del mercado.|función emblemática.|Aplicación Supabase`)
};

const fr_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grande idée.|plateforme.|produit.|build 0→1.|MVP.|moteur de revenus.|lancement.|SaaS.|vision.|jalon.|avantage concurrentiel.|levier de croissance.|évolution du marché.|fonctionnalité phare.|Application Supabase`)
};

const pt_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grande ideia.|plataforma.|produto.|0→1 build.|MVP.|mecanismo de receita.|lançamento.|SaaS.|visão.|marco.|vantagem competitiva.|alavanca de crescimento.|movimento de mercado.|recurso principal.|aplicativo Supabase`)
};

const zh_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大创意。|平台。|产品。|0→1 落地。|MVP。|收入引擎。|发布。|SaaS。|愿景。|里程碑。|竞争优势。|增长杠杆。|市场动向。|旗舰功能。|Supabase 应用`)
};

const tr_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`büyük fikir.|platform.|ürün.|0→1 build.|MVP.|gelir motoru.|lansman.|SaaS.|vizyon.|dönüm noktası.|rekabet avantajı.|büyüme kolu.|pazar hamlesi.|amiral gemisi özellik.|Supabase uygulaması`)
};

const ru_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`большая идея.|платформа.|продукт.|0→1 билд.|MVP.|денежный двигатель.|запуск.|SaaS.|видение.|этап.|конкурентное преимущество.|рычаг роста.|рыночный ход.|флагманская фича.|Supabase app`)
};

const pl_cta_words = /** @type {(inputs: Cta_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`świetny pomysł.|platforma.|produkt.|0→1 build.|MVP.|silnik przychodów.|uruchomienie.|SaaS.|wizja.|kamień milowy.|przewaga konkurencyjna.|dźwignia wzrostu.|ruch rynkowy.|funkcja flagowa.|aplikacja Supabase`)
};

/**
* | output |
* | --- |
* | "big idea.\|platform.\|product.\|0→1 build.\|MVP.\|revenue engine.\|launch.\|SaaS.\|vision.\|milestone.\|competitive edge.\|growth lever.\|market move.\|flagship feature.\|..." |
*
* @param {Cta_WordsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_words = /** @type {((inputs?: Cta_WordsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_WordsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_words(inputs)
	if (locale === "bn") return bn_cta_words(inputs)
	if (locale === "de") return de_cta_words(inputs)
	if (locale === "es") return es_cta_words(inputs)
	if (locale === "fr") return fr_cta_words(inputs)
	if (locale === "pt") return pt_cta_words(inputs)
	if (locale === "zh") return zh_cta_words(inputs)
	if (locale === "tr") return tr_cta_words(inputs)
	if (locale === "ru") return ru_cta_words(inputs)
	if (locale === "pl") return pl_cta_words(inputs)
	return en_cta_words(inputs)
});